<template>
<v-app>
    <v-main class="primary">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
        <v-toolbar elevation="0">
            <!-- <v-app-bar-nav-icon /> -->
            <v-layout row class="display-1 ml-2">
                <div id="font">
                    Simples
                </div>

                <div id="font" class="primary--text">
                    Medic
                </div>
            </v-layout>

            <v-spacer />
            <div>
                <v-card v-if="user" class="rounded-xl" outlined>
                    <v-list-item>
                        <v-icon class="mr-2">
                            person
                        </v-icon>

                        <v-list-item-content>
                            <v-list-item-title v-text="nomeFormatado(user.nome)" />
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
                <v-card v-else outlined class="rounded-xl">
                    <v-list-item>
                        <v-icon class="mr-2">
                            person
                        </v-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="'Dr(a). ' + nomeFormatado(user.nome)" />
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
            </div>
            <v-btn title="Ajuda" text icon color="primary" @click="retornarHelp()">
                <v-icon title="Ajuda">
                    info
                </v-icon>
            </v-btn>

            <v-btn title="Logout" text icon color="primary" @click="dialogLogout()">
                <v-icon v-if="user" title="Logout">
                    logout
                </v-icon>
                <v-icon v-else title="Logout">
                    power_settings_new
                </v-icon>
            </v-btn>
        </v-toolbar>
        <!--Container Principal-->
        <v-container grid-list-xl fluid>
            <!-- {{ listaPacientesDisponiveis }} -->
            <!-- Configuração do Pos Atendimento-->
            <div v-if="!mostrarTelaPrincipal && !ficha.codigo" row :class=" !mostrarTelaPrincipal && !ficha.codigo ? 'animated fadeInDown pa-5': 'animated fadeInUp pa-5'">
                <v-card class="rounded-xl px-2" color="grey lighten-5">
                    <br>
                    <v-card-title primary-title class="grey--text text--darken-2 pt-0 justify-center">
                        <div>
                            <div>
                                <v-layout row justify-center class="mensagemInicial">
                                    Olá,&ensp; <div class="primary--text"> {{ nomeFormatado(user.nome) }} </div>.
                                </v-layout>
                            </div>

                            <div class="mensagemInicial">
                                Preencha os campos abaixo de acordo com seu local de atendimento.
                            </div>
                        </div>
                    </v-card-title>
                    <!-- <v-divider class="mt-2" /> -->
                    <v-form ref="form" class="px-2" v-model="valid" lazy-validation>
                        <v-text-field name="name" label="Unidade" solo id="id" rounded v-model="user.nomeUnidade"></v-text-field>
                        <!-- <v-autocomplete rounded solo v-model="unidadeSelecionada" label="Unidade" :items="listaUnidades" item-value="idUnidade" return-object :rules="[v => !!v || 'Escolha a unidade de atendimento']" item-text="nomeUnidade" no-data-text="Nenhuma Unidade disponível" required @input="agruparLocaisPorUnidade(unidadeSelecionada)" /> -->

                        <v-autocomplete rounded solo v-model="localEscolhido" label="Local de Atendimento" :items="listaLocais" return-object item-value="idLocal" :rules="[v => !!v || 'Local obrigatório']" item-text="nomeLocal" no-data-text="Nenhum Local disponível" required />

                        <!-- <v-autocomplete rounded solo v-model="listaServicosSelecionados" label="Serviços" :items="listaServicos" item-value="idServico" return-object :rules="[v => v && v.length > 0 ||'Escolha os serviço da para seu atendimento']" item-text="nomeEspecialidade" no-data-text="Nenhum Serviço disponível" required multiple /> -->

                        <v-layout wrap align-center>
                            <v-flex xs12 sm3>
                                <v-select rounded solo v-model="descricaoLocal" :items="itensDescricaoLocal" item-text="descricao" item-value="descricao" label="Selecione o Local" return-object single-line @input="validateField" />
                            </v-flex>
                            <v-flex xs12 sm9>
                                <v-text-field rounded solo v-model="nomeConsultorio" class="pl-3" :rules="rulesLocal" label="Número" />
                            </v-flex>
                        </v-layout>
                        <v-card-actions>
                            <v-spacer />

                            <v-btn :loading="load" large rounded color="primary" :disabled="!valid" @click="adicionarServicosParaAtendimento()">
                                Iniciar Atendimentos
                            </v-btn>

                        </v-card-actions>

                    </v-form>
                    <br>
                </v-card>
            </div>
            <!-- tela Principal -->
            <div class="animated fadeInDown" v-if="(mostrarTelaPrincipal && !iniciouAtendimento)">
                <v-container grid-list-xl fluid>
                    <v-layout justify-center row wrap>
                        <v-flex xs8 sm8 md8>
                            <v-flex xs12 sm12 md12>
                                <v-card class="rounded-xl pb-4 px-1">
                                    <v-card-title class="text-center justify-center ">
                                        <h2 class="font-weight-bold basil--text">
                                            Pacientes
                                        </h2>
                                    </v-card-title>

                                    <!-- Mestrar exames e medicamentos passando idConsulta e idAtendimento-->
                                    <!-- <div v-if="idConsulta">
                                        <examesMedicamentos :idConsulta="idConsulta" :idSolicitacao="idSolicitacao" />
                                    </div> -->
                                    <v-tabs background-color="transparent" grow>
                                        <v-tab :disabled="fezChamada || isAtendimento" @click="changeColor(0)">
                                            <v-badge :dot="listaPacientesDisponiveis.length <= 0" :color="listaPacientesDisponiveis.length <= 0 ? 'grey lighten-3': 'primary'" :content="listaPacientesDisponiveis.length">
                                                Disponiveis
                                            </v-badge>

                                        </v-tab>

                                        <v-tab :disabled="fezChamada || isAtendimento" @click="changeColor(1)">
                                            <v-badge :dot="listaPacientesPendente.length <= 0" :color="listaPacientesPendente.length <= 0 ? 'grey lighten-3': 'primary'" :content="listaPacientesPendente.length">
                                                Pendentes
                                            </v-badge>
                                        </v-tab>

                                        <v-tab :disabled="fezChamada || isAtendimento" @click="changeColor(2)">
                                            <v-badge :dot="listaPacientesEspera.length <= 0" :color="listaPacientesEspera.length <= 0 ? 'grey lighten-3': 'primary'" :content="listaPacientesEspera.length">
                                                Em espera
                                            </v-badge>
                                        </v-tab>
                                        <!--DISPONÍVEIS-->

                                        <v-tab-item>

                                            <v-card class="mt-2" flat v-if="listaPacientesDisponiveis.length >= 0">
                                                <div v-show="!exibirFicha && listaPacientesDisponiveis.length > 0">
                                                    <!-- <v-text-field v-show="listaPacientesDisponiveis.length" v-model="searchDisponiveis" dense outlined class="pt-1 mx-3 mb-0 pb-0" prepend-inner-icon="search"  /> -->
                                                    <v-text-field v-show="listaPacientesDisponiveis.length" v-model="searchDisponiveis" dense outlined class="pt-1 mx-3 mb-0 pb-0" prepend-inner-icon="search" @click:clear="clearSearch" />
                                                    <v-list v-show="!ficha.codigo" :dense="true" class="scroll-y pt-0" style="" two-line>
                                                        <v-virtual-scroll :bench="0" :items="listaPacientesDisponiveisFiltrada" height="278" item-height="64">
                                                            <template v-slot:default="{ item }">
                                                                <v-list-item :key="item.title" ripple @click="toggle(index)" class="animated fadeIn">
                                                                    <v-list-item-avatar>
                                                                        <v-icon :color="(item.prioridade == 1 || item.prioridade == 3) ? 'info' : 'grey darken-1'" v-text="(item.prioridade == 1 || item.prioridade == 3) ? 'wheelchair_pickup' : 'person'"></v-icon>
                                                                    </v-list-item-avatar>
                                                                    <v-list-item-content @click="mostrarFicha(item)">
                                                                        <v-list-item-title>
                                                                            <p class="text-sm-left font-weight-bold">
                                                                                {{ item.nomePaciente }}
                                                                            </p>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                                <v-divider />
                                                            </template>
                                                        </v-virtual-scroll>
                                                    </v-list>
                                                </div>

                                                <div v-show="exibirFicha" class="animated fadeIn">
                                                    <v-container grid-list-xl fluid>
                                                        <v-card-text class="pt-0">
                                                            <h3>
                                                                <v-layout row justify-center align-center>

                                                                    <v-list :dense="true">
                                                                        <v-list-item :key="ficha.codigo" ripple>
                                                                            <v-list-item-avatar>
                                                                                <v-icon :color="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'info' : 'grey darken-1'" v-text="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'wheelchair_pickup' : 'person'"></v-icon>
                                                                            </v-list-item-avatar>
                                                                            <v-list-item-content>
                                                                                <v-list-item-title>
                                                                                    <p class="text-sm-left font-weight-bold">
                                                                                        {{ ficha.nomePaciente }}
                                                                                    </p>
                                                                                </v-list-item-title>
                                                                            </v-list-item-content>
                                                                        </v-list-item>
                                                                    </v-list>
                                                                </v-layout>
                                                            </h3>

                                                            <div v-show="show" class="animated fadeInDown">
                                                                <!-- <v-divider /> -->
                                                                <v-card-text>
                                                                    <div v-for="(consulta, index) in listaConsultasPaciente" :key="index">
                                                                        <div v-show="ficha.idExame !== consulta.idExame">
                                                                            <strong :class="consulta.colorText">
                                                                                {{ consulta.nomeExame }}
                                                                            </strong>
                                                                            <v-divider v-if="index + 1 < listaConsultasPaciente.length" :key="index" />
                                                                        </div>
                                                                    </div>
                                                                </v-card-text>
                                                            </div>

                                                            <!--  <div justify-end>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <button @click="onCopy(ficha.idOrdemServico)" type="button" v-on="on">
                                                                            Copiar O.S! 2
                                                                        </button>

                                                                    </template>
                                                                    <span>{{ textClipBoard }}</span>
                                                                </v-tooltip>
                                                            </div>
                                                            <strong>OS: {{ficha.idOrdemServico}}</strong> -->
                                                        </v-card-text>
                                                        <v-divider />
                                                        <v-card-actions class="text-center">
                                                            <v-btn v-show="!fezChamada || emPacientePendente" :disabled="isAtendimento" light text rounded color="" @click="exibirFicha = false">
                                                                <v-icon left>
                                                                    keyboard_backspace
                                                                </v-icon>voltar
                                                            </v-btn>
                                                            <v-btn :disabled="desabilitaBotaoChamar" light outlined rounded @click="fazerChamada()">
                                                                chamar
                                                                <v-icon right>
                                                                    record_voice_over
                                                                </v-icon>
                                                            </v-btn>

                                                        </v-card-actions>
                                                        <v-divider />
                                                        <v-card-actions>

                                                            <!-- <v-btn v-show="isEspera && !iniciouAtendimento" depressed class="white--text " rounded color="primary" @click="reiniciarAtendimento()">
                                                                Continuar Atendimento

                                                            </v-btn>

                                                            <v-btn v-show="isEspera && !iniciouAtendimento" outlinedd class="rounded-card white--text " color="quadradoB" @click="voltar()">
                                                                Voltar
                                                            </v-btn> -->

                                                            <v-btn v-show="!iniciouAtendimento && !isEspera" depressed :disabled="!fezChamada" class="white--text" rounded large color="primary" @click="iniciarAtendimento()">
                                                                <div> Iniciar Atendimento </div>

                                                            </v-btn>

                                                            <!-- <v-btn v-show="iniciouAtendimento" depressed class="white--text" :disabled="!ficha.nomeEspecialidade" rounded large color="primary" @click="retornarConsultasPaciente(1)">
                                                                Encerrar Atendimento
                                                            </v-btn> -->

                                                            <v-btn v-if="!isAtendimento && !isEspera" large outlinedd class="rounded-card white--text" color="red lighten-1" :disabled="!habilitarBotaoCronometro" @click="dialogNaoCompareceu = true">
                                                                não compareceu {{ textCronometroRegressivo }}
                                                            </v-btn>

                                                            <!--<v-btn v-if="isAtendimento" large depressed outlinedd class="rounded-card white--text" color="secondary" @click="atendimentoEmEspera()">
                                                                Adicionar a lista de Espera
                                                            </v-btn> -->
                                                            <!--DISPONIVEIS-->

                                                        </v-card-actions>
                                                    </v-container>
                                                </div>

                                            </v-card>
                                            <div v-if="listaPacientesDisponiveis.length == 0 && !exibirFicha">
                                                <v-card flat width="434">
                                                    <div v-for="i in 6" :key="i">
                                                        <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line" :loading="true" title="Aguardando pacientes"></v-skeleton-loader>
                                                    </div>
                                                </v-card>
                                            </div>
                                        </v-tab-item>

                                        <!-- PENDENTES-->
                                        <v-tab-item>
                                            <v-container grid-list-xl fluid>
                                                <v-card flat v-if="listaPacientesPendente.length >= 0">
                                                    <div v-show="!exibirFicha && listaPacientesPendente.length > 0">
                                                        <v-list :dense="true" class="scroll-y" style="" two-line>
                                                            <v-virtual-scroll :bench="0" :items="listaPacientesPendente" height="278" item-height="64">
                                                                <template v-slot:default="{ item }">
                                                                    <v-list-item :key="item.title" ripple @click="toggle(index)" class="animated fadeIn">
                                                                        <v-list-item-avatar>
                                                                            <v-icon :color="(item.prioridade == 1 || item.prioridade == 3) ? 'info' : 'grey darken-1'" v-text="(item.prioridade == 1 || item.prioridade == 3) ? 'wheelchair_pickup' : 'person'"></v-icon>
                                                                        </v-list-item-avatar>
                                                                        <v-list-item-content @click="mostrarFicha(item)">
                                                                            <v-list-item-title>
                                                                                <p class="text-sm-left font-weight-bold">
                                                                                    {{ item.nomePaciente }}
                                                                                </p>
                                                                            </v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                    <v-divider />
                                                                </template>
                                                            </v-virtual-scroll>
                                                        </v-list>
                                                    </div>

                                                    <div v-show="exibirFicha" class="animated fadeIn">

                                                        <v-list :dense="true">
                                                            <v-list-item :key="ficha.codigo" ripple>
                                                                <v-list-item-avatar>
                                                                    <v-icon :color="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'info' : 'grey darken-1'" v-text="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'wheelchair_pickup' : 'person'"></v-icon>
                                                                </v-list-item-avatar>
                                                                <v-list-item-content>
                                                                    <v-list-item-title>
                                                                        <p class="text-sm-left font-weight-bold">
                                                                            {{ ficha.nomePaciente }}
                                                                        </p>
                                                                    </v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>

                                                        <!--  <v-card-text class="pt-0">
                                                            <h3>
                                                                <v-layout row justify-center align-center>
                                                                    Exame(s):
                                                                    <div class="pl-2">
                                                                        {{ ficha.nomeExame }}
                                                                    </div>

                                                                    <v-btn v-show="listaConsultasPaciente.length" icon small @click="show = !show">
                                                                        + {{ listaConsultasPaciente.length - 1 }}
                                                                    </v-btn>
                                                                </v-layout>
                                                            </h3>

                                                            <div v-show="show" class="animated fadeInDown">
                                                               
                                                                <v-card-text>
                                                                    <div v-for="(consulta, index) in listaConsultasPaciente" :key="index">
                                                                        <div v-show="ficha.idExame !== consulta.idExame">
                                                                            <strong :class="consulta.colorText">
                                                                                {{ consulta.nomeExame }}
                                                                            </strong>
                                                                            <v-divider v-if="index + 1 < listaConsultasPaciente.length" :key="index" />
                                                                        </div>
                                                                    </div>
                                                                </v-card-text>
                                                            </div>

                                                             <div justify-end>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <button @click="onCopy(ficha.idOrdemServico)" type="button" v-on="on">
                                                                            Copiar O.S!
                                                                        </button>

                                                                    </template>
                                                                    <span>{{ textClipBoard }}</span>
                                                                </v-tooltip>
                                                            </div>
                                                            <strong>OS: {{ficha.idOrdemServico}}</strong> 
                                                        </v-card-text>-->
                                                        <v-divider />
                                                        <v-card-actions class="text-center">
                                                            <v-btn v-show="!fezChamada || emPacientePendente" :disabled="isAtendimento" light text rounded color="" @click="exibirFicha = false">
                                                                <v-icon left>
                                                                    keyboard_backspace
                                                                </v-icon>voltar
                                                            </v-btn>
                                                            <v-btn :disabled="desabilitaBotaoChamar" light outlined rounded @click="fazerChamada()">
                                                                chamar
                                                                <v-icon right>
                                                                    record_voice_over
                                                                </v-icon>
                                                            </v-btn>

                                                        </v-card-actions>
                                                        <v-divider />
                                                        <v-card-actions v-if="exibirFicha">

                                                            <v-btn v-show="isEspera && !iniciouAtendimento" depressed class="white--text " rounded color="primary" @click="reiniciarAtendimento()">
                                                                Continuar Atendimento

                                                            </v-btn>

                                                            <v-btn v-show="isEspera && !iniciouAtendimento" outlinedd class="rounded-card white--text " color="quadradoB" @click="voltar()">
                                                                Voltar
                                                            </v-btn>

                                                            <v-btn v-show="!iniciouAtendimento && !isEspera" depressed :disabled="!isPendentes" class="white--text" rounded large color="primary" @click="iniciarAtendimento()">
                                                                Iniciar Atendimento

                                                            </v-btn>

                                                            <v-btn v-if="!isAtendimento && !isEspera" large outlinedd class="rounded-card white--text" color="red lighten-1" :disabled="!fezChamada || !habilitarBotaoCronometro || isAtendimento " @click="dialogNaoCompareceu = true">
                                                                não compareceu {{ textCronometroRegressivo }}
                                                            </v-btn>

                                                            <v-btn v-if="isAtendimento" large depressed outlinedd class="rounded-card white--text" color="secondary" @click="atendimentoEmEspera()">
                                                                Adicionar a lista de Espera
                                                            </v-btn>

                                                        </v-card-actions>
                                                    </div>
                                                </v-card>
                                                <div v-if="listaPacientesPendente.length == 0 && !exibirFicha">
                                                    <v-card flat width="434">
                                                        <div v-for="i in 6" :key="i">
                                                            <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line" :loading="true"></v-skeleton-loader>
                                                        </div>
                                                    </v-card>
                                                </div>
                                            </v-container>
                                        </v-tab-item>
                                        <!--EM ESPERA-->
                                        <v-tab-item>
                                            <v-container grid-list-xl fluid>
                                                <v-card flat v-if="listaPacientesEspera.length >= 0">
                                                    <div v-show="!exibirFicha && listaPacientesEspera.length > 0">
                                                        <v-list :dense="true" style="overflow-y: auto;" two-line>

                                                            <v-virtual-scroll :bench="0" :items="listaPacientesEspera" height="278" item-height="64">
                                                                <template v-slot:default="{ item }">
                                                                    <v-list-item :key="item.title" ripple @click="toggle(index)" class="animated fadeIn">
                                                                        <v-list-item-avatar>
                                                                            <v-icon :color="(item.prioridade == 1 || item.prioridade == 3) ? 'info' : 'grey darken-1'" v-text="(item.prioridade == 1 || item.prioridade == 3) ? 'wheelchair_pickup' : 'person'"></v-icon>
                                                                        </v-list-item-avatar>
                                                                        <v-list-item-content @click="mostrarFicha(item)">
                                                                            <v-list-item-title>
                                                                                <p class="text-sm-left font-weight-bold">
                                                                                    {{ item.nomePaciente }}
                                                                                </p>
                                                                            </v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                    <v-divider />
                                                                    <!-- <v-divider v-if="index + 1 < listaPacientesEspera.length" :key="index" /> -->
                                                                </template>
                                                            </v-virtual-scroll>
                                                        </v-list>
                                                    </div>
                                                    <div v-show="exibirFicha" class="animated fadeIn">
                                                        <v-list :dense="true">
                                                            <v-list-item :key="ficha.codigo" ripple>
                                                                <v-list-item-avatar>
                                                                    <v-icon :color="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'info' : 'grey darken-1'" v-text="(ficha.prioridade == 1 || ficha.prioridade == 3) ? 'wheelchair_pickup' : 'person'"></v-icon>
                                                                </v-list-item-avatar>
                                                                <v-list-item-content>
                                                                    <v-list-item-title>
                                                                        <p class="text-sm-left font-weight-bold">
                                                                            {{ ficha.nomePaciente }}
                                                                        </p>
                                                                    </v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>

                                                        <!--  <v-card-text class="pt-0">
                                                            <h3>
                                                                <v-layout row justify-center align-center>
                                                                    Exame(s):
                                                                    <div class="pl-2">
                                                                        {{ ficha.nomeExame }}
                                                                    </div>

                                                                    <v-btn v-show="listaConsultasPaciente.length" icon small @click="show = !show">
                                                                        + {{ listaConsultasPaciente.length - 1 }}
                                                                    </v-btn>
                                                                </v-layout>
                                                            </h3>

                                                            <div v-show="show" class="animated fadeInDown">
                                                            
                                                                <v-card-text>
                                                                    <div v-for="(consulta, index) in listaConsultasPaciente" :key="index">
                                                                        <div v-show="ficha.idExame !== consulta.idExame">
                                                                            <strong :class="consulta.colorText">
                                                                                {{ consulta.nomeExame }}
                                                                            </strong>
                                                                            <v-divider v-if="index + 1 < listaConsultasPaciente.length" :key="index" />
                                                                        </div>
                                                                    </div>
                                                                </v-card-text>
                                                            </div>

                                                            <div justify-end>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <button @click="onCopy(ficha.idOrdemServico)" type="button" v-on="on">
                                                                            Copiar O.S!
                                                                        </button>

                                                                    </template>
                                                                    <span>{{ textClipBoard }}</span>
                                                                </v-tooltip>
                                                            </div>
                                                            <strong>OS: {{ficha.idOrdemServico}}</strong> 
                                                        </v-card-text>-->
                                                        <!-- <v-card-actions class="text-center">
                                                            <v-btn v-show="!fezChamada || emPacientePendente" :disabled="isAtendimento" light text rounded color="" @click="exibirFicha = false">
                                                                <v-icon left>
                                                                    keyboard_backspace
                                                                </v-icon>voltar
                                                            </v-btn>
                                                            <v-btn :disabled="desabilitaBotaoChamar" light outlined rounded @click="fazerChamada()">
                                                                chamar
                                                                <v-icon right>
                                                                    record_voice_over
                                                                </v-icon>
                                                            </v-btn>

                                                        </v-card-actions> -->
                                                        <v-divider />
                                                        <v-card-actions v-if="exibirFicha">

                                                            <v-btn v-show="isEspera && !iniciouAtendimento" depressed class="white--text " rounded color="primary" @click="reiniciarAtendimento()">
                                                                Continuar Atendimento

                                                            </v-btn>

                                                            <v-btn v-show="isEspera && !iniciouAtendimento" outlinedd class="rounded-card white--text " color="quadradoB" @click="exibirFicha = false">
                                                                Voltar
                                                            </v-btn>

                                                        </v-card-actions>
                                                    </div>
                                                </v-card>
                                                <div v-if="listaPacientesEspera.length == 0 && !exibirFicha">
                                                    <v-card flat width="434">
                                                        <div v-for="i in 6" :key="i">
                                                            <v-skeleton-loader class="mx-auto" type="list-item-avatar-two-line" :loading="true"></v-skeleton-loader>
                                                        </div>
                                                    </v-card>
                                                </div>
                                            </v-container>
                                        </v-tab-item>
                                    </v-tabs>

                                    <v-dialog v-model="dialogMeusAtendimentos" hide-overlay fullscreen persistent transition="dialog-bottom-transition">
                                        <div v-if="dialogMeusAtendimentos" >
                                            <atendimentos @fechar="dialogMeusAtendimentos = false" style="overflow-x: hidden;" />
                                        </div>
                                    </v-dialog>

                                    <v-speed-dial v-model="fab" right absolute bottom fab>
                                        <template v-slot:activator>
                                            <v-btn v-model="fab" color="blue darken-2" dark fab right>
                                                <v-icon v-if="fab">
                                                    mdi-close
                                                </v-icon>
                                                <v-icon v-else>
                                                    more_vert
                                                </v-icon>
                                            </v-btn>
                                        </template>

                                        <v-tooltip right>
                                            <template v-slot:activator="{ attrs, on }">
                                                <v-btn dark small fab color="indigo" v-bind="attrs" v-on="on" @click="dialogMeusAtendimentos = true">
                                                    <v-icon color="white">history</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Meus Atendimentos</span>
                                        </v-tooltip>

                                        <v-tooltip right>
                                            <template v-slot:activator="{ attrs, on }">                                            
                                                <v-btn small fab color="orange" v-bind="attrs" v-on="on" @click="dialogEstatisticas = true">
                                                    <v-icon color="white">trending_up</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Estatísticas</span>
                                        </v-tooltip>

                                    </v-speed-dial>
                                    <!--TESTE FORA DO SPEED-DIAL -->
                                    <!--Botão para limpar listaConsultasPaciente-->

                                    <!-- <v-card-actions>
                                    <v-spacer />
                                    <v-btn v-show="listaConsultasPaciente.length" small @click="limparListaConsultasPaciente = []">
                                        <v-icon>clear</v-icon>
                                    </v-btn>
                                </v-card-actions> -->
                                </v-card>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>

        </v-container>
        <!-- LISTAR ATENDIMENTOS DO PACIENTE -->
        <div v-show="iniciouAtendimento" class="animated fadeInLeft">
            <v-container grid-list-xl fluid>

                <v-layout justify-center row wrap>
                    <v-flex xs8 sm8 md8>
                        <v-flex xs12 sm12 md12>
                            <v-card class="rounded-xl pb-4 px-1">

                                <v-toolbar class="transparent" :elevation="0" rounded>
                                    <v-tooltip bottom v-if="exibirSolicitacoes">
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" icon @click="exibirSolicitacoes = false">
                                                <v-icon>
                                                    arrow_back
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Voltar</span>
                                    </v-tooltip>
                                    <v-card-title>
                                        <v-row>

                                            <span>
                                                <v-icon class="ma-1 pb-" color="primary">
                                                    person
                                                </v-icon>
                                                {{ ficha.nomePaciente }}
                                            </span>

                                            <v-spacer />

                                        </v-row>
                                    </v-card-title>
                                    <!-- <v-toolbar-title class="text-center justify-center">
                                        <v-icon class="mr-2 mt-0" color="primary">
                                            mdi-doctor
                                        </v-icon>
                                        <span> Adriana Farias </span> 
                                    </v-toolbar-title> -->
                                    <v-spacer></v-spacer>
                                    <div class="display-1">
                                        {{ tempoAtendimento }}
                                    </div>
                                </v-toolbar>

                                <v-divider class="mb-2"></v-divider>

                                <!--Mostrar a lista de listaConsultasPaciente-->
                                <div v-if=" loadConsultas && !exibirSolicitacoes">
                                    <v-card flat v-for="(i) in 5" :key="i">
                                        <v-skeleton-loader type="list-item, divider"></v-skeleton-loader>
                                    </v-card>
                                </div>
                                <div v-show="listaConsultasPaciente.length > 0 && !exibirSolicitacoes">
                                    <v-list :dense="true" class="scroll-y pt-0" style="" two-line>
                                        <v-virtual-scroll :bench="0" :items="listaConsultasPaciente" height="278" item-height="85">
                                            <template v-slot:default="{ item }">
                                                <v-list-item :key="item.idConsulta" ripple @click="toggle(index)" class="animated fadeIn">
                                                    <v-list-item-avatar>
                                                        <v-icon :color="(item.prioridade == 1 || item.prioridade == 3) ? 'info' : 'grey darken-1'" v-text="(item.prioridade == 1 || item.prioridade == 3) ? 'wheelchair_pickup' : 'person'"></v-icon>
                                                    </v-list-item-avatar>
                                                    <v-list-item-content @click="idMedico = item.idMedico, idPrestador = item.idPrestador, idConsulta = item.idConsulta, idSolicitacao = item.idSolicitacao, exibirSolicitacoes = true, listarSolicitacoesDeExames(item.idSolicitacao), listarSolicitacoesMedicamentos (idConsulta) ">
                                                        <v-list-item-title>
                                                            <p class="text-sm-left font-weight-bold">
                                                                {{ item.nome }}
                                                            </p>
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            <!-- Campo dataSaida com a data formatada -->
                                                            <p class="text-sm-left">
                                                                {{ formatarData(item.dataSaida) }}
                                                            </p>
                                                        </v-list-item-subtitle>

                                                    </v-list-item-content>
                                                   
                                                     <v-icon color="green">{{
                                                        item.idSolicitacaoPos && item.idSolicitacaoLaboratorioPos != null ? 'done_all' :
                                                        item.idSolicitacaoPos || item.idSolicitacaoLaboratorioPos? 'done':'alert'
                                                      }}</v-icon> 
                                                </v-list-item>
                                                <v-divider />
                                            </template>
                                        </v-virtual-scroll>
                                    </v-list>

                                </div>
                                <!-- SOLICITACOES-->
                                <v-card v-show="exibirSolicitacoes" flat class=" pb-4 px-1 animated fadeIn">
                                    <!-- <v-card-title>
                                        <v-row>
                                            <v-cols>
                                                <span>
                                                    <v-icon class="mr-2" color="primary">
                                                        person
                                                    </v-icon>
                                                    {{ ficha.nomePaciente }}
                                                </span>
                                            </v-cols>
                                            <v-spacer />

                                        </v-row>
                                    </v-card-title> -->

                                    <v-card flat align="center" :loading="loadSolicitacoes" :disabled="loadSolicitacoes">
                                        <v-tabs background-color="primary darken-4" dark v-model="tabSolicitacoes" align-with-center fixed-tabs>
                                            <v-tabs-slider color="orange"></v-tabs-slider>
                                            <v-tab>
                                                <v-badge color="transparent">
                                                    <template v-slot:badge>
                                                        <span class="orange--text">
                                                            {{ solicitacoesExames.length }}
                                                        </span>
                                                    </template>
                                                    Exames
                                                </v-badge>
                                            </v-tab>
                                            <v-tab>
                                                <v-badge color="transparent">
                                                    <template v-slot:badge>
                                                        <span class="orange--text">
                                                            {{ solicitacoesExamesLaboratoriais.length }}
                                                        </span>
                                                    </template>
                                                    Exames Laboratório
                                                </v-badge>
                                            </v-tab>
                                            <v-tab>
                                                <v-badge color="transparent">
                                                    <template v-slot:badge>
                                                        <span class="orange--text">
                                                            {{ listaSolicitacoesDeMedicamentos.length }}
                                                        </span>
                                                    </template>
                                                    Medicamentos
                                                </v-badge>
                                            </v-tab>
                                            <!--EXAMES -->
                                            <v-tab-item>

                                                <v-card outline class="pa-2">
                                                    <v-data-table  dense height="350" :headers="headers" :items="solicitacoesExames" class="elevation-1" :items-per-page="8">
                                                        <template v-slot:top>
                                                            <v-toolbar flat>
                                                                <v-toolbar-title>
                                                                    <div class="green--text ml-2" v-show="!loadMoney">{{ orcamentoExames }}</div>
                                                                </v-toolbar-title>
                                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                                <v-autocomplete class="mt-5" @change="searchExame = ''" v-model="exame1" :items="items" :loading="isLoading" :search-input.sync="searchExame" white hide-no-data hide-selected item-text="apelido" item-value="API" label="Buscar exames" placeholder="Buscar exame" prepend-icon="mdi-database-search" return-object></v-autocomplete>
                                                                <!-- <v-spacer></v-spacer> -->
                                                                <!-- <v-dialog v-model="dialogDelete" max-width="500px">
                                                                <v-card>
                                                                    <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                                                                    <v-card-actions>
                                                                        <v-spacer></v-spacer>
                                                                        <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                                                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                                                        <v-spacer></v-spacer>
                                                                    </v-card-actions>
                                                                </v-card>
                                                            </v-dialog> -->
                                                            </v-toolbar>
                                                        </template>
                                                        <template v-slot:item.valor="{ item }">

                                                            <strong v-if="item.valor" class="green--text">{{ item.valor }}</strong>
                                                            <v-icon v-else color="#E17833">warning</v-icon>
                                                        </template>
                                                        <template v-slot:item.actions="{ item }">

                                                            <v-btn :loading="loadMoney" icon @click="deleteItem(item, 1)">
                                                                <v-icon color="red">mdi-delete</v-icon>
                                                            </v-btn>
                                                        </template>

                                                    </v-data-table>
                                                    <v-card-actions>
                                                        <v-spacer />
                                                        <!-- Imprimir orçamento -->
                                                        <!-- <v-btn :loading="loadMoney" outlined @click="gerarOrcamento(1)" class="mr-2" color="green">
                                                            <v-icon left>
                                                                payments
                                                            </v-icon>
                                                            <span>Gerar Orçamento</span>
                                                        </v-btn> -->
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on }">
                                                                <v-btn :loading="loadSolicitacao" :disabled="ficha.idSolicitacaoPos != null || loadMoney || alertOrcamento" v-on="on" @click="gerarVoucher(1)" class="mr-2" color="primary">
                                                                    <v-icon left>
                                                                        local_printshop
                                                                    </v-icon>
                                                                    <span>Gerar Voucher</span>
                                                                </v-btn>
                                                            </template>
                                                            <span> Gerar Voucher </span>
                                                        </v-tooltip>

                                                    </v-card-actions>
                                                    <v-alert dense color="#E17833" border="left" type="warning" v-show="alertOrcamento">
                                                        <strong>Importante:</strong> <span> Exame de valor inestimável detectado! Por favor, acione o setor de faturamento. Além disso, lembre-se de remover o exame sem valor estimado para que possamos gerar um voucher adequado.</span>
                                                    </v-alert>
                                                    <!-- APAGAR EXAMES-->
                                                    <v-dialog v-model="isDelete" max-width="350" persistent>
                                                        <v-card>
                                                            <v-card-title class="text-h7">
                                                                Tem certeza que quer apagar este exame?
                                                            </v-card-title>

                                                            <v-card-actions>
                                                                <v-spacer></v-spacer>
                                                                <v-btn color="red darken-1" text @click="isDelete = false">
                                                                    Cancelar
                                                                </v-btn>
                                                                <v-btn color="green darken-1" text @click="isDelete = false, solicitacoesExames.splice(indexExame, 1)">
                                                                    Confirmar
                                                                </v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-dialog>
                                                    <v-alert type="info" v-show="ficha.idSolicitacaoPos != null" text dense :value="true">
                                                        Esse voucher já foi gerado!
                                                    </v-alert>
                                                </v-card>
                                            </v-tab-item>
                                            <!--EXAMES LABORATÓRIO-->
                                            <v-tab-item>

                                                <v-card class="pa-2">
                                                    <v-data-table  dense height="350" :headers="headers" :items="solicitacoesExamesLaboratoriais" class="elevation-1" :items-per-page="8">
                                                        <template v-slot:top>
                                                            <v-toolbar flat>
                                                                <v-toolbar-title>
                                                                    <div class="green--text ml-2" v-show="!loadMoney">{{ orcamentoExamesLaboratoriais }}</div>
                                                                </v-toolbar-title>
                                                                <v-divider class="mx-4" inset vertical></v-divider>
                                                                <v-autocomplete class="mt-5" @change="searchExame2 = ''" v-model="exame2" :items="items" :loading="isLoading" :search-input.sync="searchExame2" white hide-no-data hide-selected item-text="apelido" item-value="API" label="Buscar exames" placeholder="Buscar exame" prepend-icon="mdi-database-search" return-object></v-autocomplete>
                                                                <!-- <v-spacer></v-spacer> -->
                                                                <!-- <v-dialog v-model="dialogDelete" max-width="5s00px">
                                                                <v-card>
                                                                    <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                                                                    <v-card-actions>
                                                                        <v-spacer></v-spacer>
                                                                        <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                                                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                                                        <v-spacer></v-spacer>
                                                                    </v-card-actions>
                                                                </v-card>
                                                            </v-dialog> -->
                                                            </v-toolbar>
                                                        </template>
                                                        <template v-slot:item.valor="{ item }">

                                                            <strong v-if="item.valor" class="green--text">{{ item.valor }}</strong>
                                                            <v-icon v-else color="#E17833">warning</v-icon>
                                                        </template>
                                                        <template v-slot:item.actions="{ item }">

                                                            <v-btn :loading="loadMoney" icon @click="deleteItem(item, 2)">
                                                                <v-icon color="red">mdi-delete</v-icon>
                                                            </v-btn>
                                                        </template>

                                                    </v-data-table>
                                                    <!-- {{ solicitacoesExamesLaboratoriais }} -->
                                                    <!-- <b-table
                                                        :data="isEmpty ? [] : solicitacoesExamesLaboratoriais"
                                                        :columns="columns">

                                                        <b-table-column field="id" label="ID" width="40" numeric v-slot="props">
                                                            {{ props.row }}
                                                        </b-table-column>


                                                        <template #empty>
                                                            <div class="has-text-centered">No records</div>
                                                        </template>

                                                    </b-table> -->
                                                    <v-card-actions>
                                                        <v-spacer />
                                                        <!-- Imprimir orçamento -->
                                                        <!-- <v-btn :loading="loadMoney" outlined @click="gerarOrcamento(2)" class="mr-2" color="green">
                                                            <v-icon left>
                                                                payments
                                                            </v-icon>
                                                            <span>Gerar Orçamento</span>
                                                        </v-btn> -->
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on }">
                                                                <v-btn v-on="on" :loading="loadSolicitacao" :disabled="ficha.idSolicitacaoLaboratorio != null || loadMoney || alertOrcamentoLaboratorial" class="mr-2" color="primary" @click="gerarVoucher(2)">
                                                                    <v-icon>
                                                                        local_printshop
                                                                    </v-icon>
                                                                    <span>Gerar Voucher</span>
                                                                </v-btn>
                                                            </template>
                                                            <span> Gerar Voucher </span>
                                                        </v-tooltip>
                                                    </v-card-actions>
                                                    <v-alert dense color="#E17833" border="left" type="warning" v-show="alertOrcamentoLaboratorial">
                                                        <strong>Importante:</strong> <span> Exame de valor inestimável detectado! Por favor, acione o setor de faturamento. Além disso, lembre-se de remover o exame sem valor estimado para que possamos gerar um voucher adequado.</span>
                                                    </v-alert>
                                                    <!-- APAGAR EXAMES LABORATÓRIAIS-->
                                                    <v-dialog v-model="isDeleteLab" max-width="350" persistent>
                                                        <v-card>
                                                            <v-card-title class="text-h7">
                                                                Tem certeza que quer apagar este exame?
                                                            </v-card-title>

                                                            <v-card-actions>
                                                                <v-spacer></v-spacer>
                                                                <v-btn color="red darken-1" text @click="isDeleteLab = false">
                                                                    Cancelar
                                                                </v-btn>
                                                                <v-btn color="green darken-1" text @click="solicitacoesExamesLaboratoriais.splice(indexExameLab, 1), isDeleteLab= false">
                                                                    Confirmar
                                                                </v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-dialog>
                                                    <v-alert type="info" v-show="ficha.idSolicitacaoLaboratorio != null" text dense :value="true">
                                                        Esse voucher já foi gerado!
                                                    </v-alert>
                                                </v-card>
                                            </v-tab-item>
                                            <!--MEDICAMENTOS -->
                                            <v-tab-item>
                                                <v-card flat class="ma-3">
                                                    <v-card-title class="grey-text headline lighten-2">
                                                        Medicamentos
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <v-list dense style="overflow-y: auto;" max-height="150">
                                                            <v-list-item v-for="item in listaSolicitacoesDeMedicamentos" :key="item.idSolicitacaoMedicamento" ripple>
                                                                <v-list-item-avatar>
                                                                    <v-icon color="info">vaccines</v-icon>
                                                                </v-list-item-avatar>
                                                                <div class="font-weight-medium text-body-2">
                                                                    {{ item.nome }}
                                                                </div>

                                                            </v-list-item>
                                                        </v-list>
                                                    </v-card-text>
                                                    <v-spacer />
                                                    <v-card-actions bottom>
                                                        <v-spacer />

                                                        <v-tooltip bottom>

                                                            <template v-slot:activator="{on}">
                                                                <v-btn v-on="on" disabled class="mr-2" color="primary">
                                                                    <v-icon>
                                                                        local_printshop
                                                                    </v-icon>
                                                                    <span>Gerar Voucher (Em Desenvolvimento)</span>
                                                                </v-btn>

                                                            </template>
                                                            <span> Gerar Voucher </span>
                                                        </v-tooltip>

                                                    </v-card-actions>
                                                </v-card>
                                            </v-tab-item>
                                        </v-tabs>
                                        <v-alert class="mx-3" v-show="erroVoucher" type="error" text dense>
                                            {{erroVoucher}}
                                        </v-alert>
                                    </v-card>
                                </v-card>

                                <v-card-actions v-if="!exibirSolicitacoes">
                                    <v-spacer />
                                    <v-btn color="orange lighten-3" @click="atendimentoEmEspera()"> Adicionar a lista de Espera</v-btn>
                                    <v-btn :loading="loadEncerrar" color="primary" @click="dialogEncerrarAtendimento = true"> Encerrar Atendimento</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-flex>

                </v-layout>

            </v-container>
        </div>

        <!--para apagar-->

        <div>
            <!-- Dialog confirmando o encerramento das consultas do atendimento-->
            <v-dialog v-model="dialogEncerrarAtendimento" persistent max-width="490">
                <v-card>
                    <v-card-title class="white--text headline red lighten-2">
                        Deseja encerrar o atendimento?
                    </v-card-title>
                    <v-card-text>As consultas serão encerradas.</v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="green darken-1" text @click="dialogEncerrarAtendimento = false">
                            Não
                        </v-btn>
                        <v-btn color="green darken-1" text @click="encerrarConsultas()">
                            Sim
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogNaoCompareceu" persistent max-width="490">
                <!-- <template v-slot:activator="{ on }" /> -->
                <v-card>
                    <v-card-title class="white--text headline red lighten-2">
                        Deseja alocar este Paciente na lista de Pacientes pendentes?
                    </v-card-title>
                    <v-card-text>O Paciente será adicionado na lista de Pacientes pendentes.</v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="green darken-1" text @click="dialogNaoCompareceu = false">
                            Não
                        </v-btn>
                        <v-btn color="green darken-1" text @click="chamadaNaoAtendida()">
                            Sim
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="aguardandoConexao" persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Aguardando conexão...
                        <v-progress-linear indeterminate color="white" class="mb-0" />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </v-main>
</v-app>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import {
    mask
} from "vue-the-mask";
import Typed from "typed.js";
import {
    getToken,
    setToken
} from "../store/auth";
import posAtendimentoService from "../services/posAtendimento.service";
import medicoService from "../services/medico.service";
import socketService from "../services/socket.service";
import HelperMedico from "./../components/helper/Helper";
import Prontuario from '../components/medico/prontuario.vue';
import Estatisticas from '../components/medico/estatisticas.vue'
import Atendimentos from '../components/posAtendimento/atendimentos.vue'
import Anamnese from '../components/tecnico/anamneseTexto.vue'
import examesMedimantos from '../components/posAtendimento/examesMedicamentos.vue'
import moment from 'moment'
import api from "sha1";
export default {
    name: "PosAtendimento",
    directives: {
        mask
    },
    components: {
        'examesMedicamentos': examesMedimantos,
        HelperMedico,
        'prontuario': Prontuario,
        'anamnese': Anamnese,
        'estatisticas': Estatisticas,
        'atendimentos': Atendimentos
    },
    data() {
        return {
            values: 'foo',
            value: null,
            headers: [{
                    text: 'Nome',
                    value: 'apelido',
                },
                {
                    text: 'Valor',
                    value: 'valor'
                },
                {
                    text: '',
                    fixedTabs: true,
                    value: 'actions',
                }
            ],
            columns: [{
                        field: 'id',
                        label: 'ID',
                        width: '40',
                        numeric: true
                    }],
            listaPacientesDisponiveis: [],
            listaPacientesPendente: [],
            idASolicitacao: "",
            idConsulta: "",
            searchExame: '',
            searchExame2: '',
            dialogEncerrarAtendimento: false,
            erroVoucher: '',
            listaPacientesEspera: [],
            listaConsultasPacienteAgrupada: [],
            listaLocais: [],
            isLoading: false,
            exame1: "",
            exame2: "",
            show: false,
            selected: [2],
            Socket: '',
            socketAux: '',
            loadEncerrar: false,
            index: 1,
            localEscolhido: "",
            aguardandoConexao: false,
            listaUnidades: [],
            iniciouAtendimento: false,
            listaServicos: [],
            nomeConsultorioCompleto: "",
            textClipBoard: "Copiar O.S",
            loadSolicitacao: false,
            entries: [],
            solicitacoesExames: [],
            solicitacoesExamesLaboratoriais: [],
            user: '',
            step: '',
            listaServicosSelecionados: "",
            dialogChamadaJaFeita: false,
            mensagemNotificacaoSocket: '',
            tempoAtendimento: "00:00:00",
            orcamentoExames: '0',
            orcamentoExamesLaboratoriais: '0',
            habilitarBotaoCronometro: false,
            fezChamada: false,
            dialogNaoCompareceu: false,
            fesChamada: false,
            isAtendimento: false,
            idUnidadeNegocio: '',
            descricaoLocal: '',
            itensDescricaoLocal: [{
                    descricao: "Laboratório ",
                    valor: "Laboratório "
                },
                {
                    descricao: "Consultório ",
                    valor: "Consultório "
                },
                {
                    descricao: "Sala ",
                    valor: "Sala "
                },
                {
                    descricao: "Outros ",
                    valor: ""
                }
            ],
            load: false,
            mostrarTelaPrincipal: false,
            nomeConsultorio: '',
            rulesLocal: [],
            listaConsultasPaciente: [],
            listaSolicitacoesDeExames: [],
            listaSolicitacoesDeMedicamentos: [],
            listaPacientesDisponiveis: [],
            exibirFicha: false,
            isEspera: false,
            isPendentes: false,
            desabilitaBotaoChamar: false,
            emPacientePendente: false,
            currtentFicha: {},
            textCronometroRegressivo: "[00:40]",
            minutesRegressivo: "",
            unidadesAgrupadas: [],
            secondsRegressivo: "",
            loadSolicitacoes: false,
            exibirSolicitacoes: false,
            atendimentoAux: false,
            alertOrcamentoLaboratorial: false,
            alertOrcamento: false,
            // listaPacientesDisponiveis: [{nomePaciente: "PACIENTE FERREIRA DOS ANJOS", nomeExame: "ASO EXAME CLINICO", nomeEspecialidade: "MEDICINA OCUPACIONAL", idConsulta: 1}, {nomePaciente: "PACIENTE FERREIRA DOS ANJOS", nomeExame: "ASO EXAME CLINICO", nomeEspecialidade: "MEDICINA OCUPACIONAL", idConsulta: 2}, {nomePaciente: "PACIENTE FERREIRA DOS ANJOS", nomeExame: "ASO EXAME CLINICO", nomeEspecialidade: "MEDICINA OCUPACIONAL", idConsulta: 3}],
            valid: true,
            ficha: {
                codigo: "",
                idServico: "",
                nomeEspecialidade: "",
                idAtendimento: "",
                idLocal: "",
                nomePaciente: "",
                status: "",
                idExame: "",
                prioridade: "",
                dataStatus: null,
                dataFinalAtendimento: null,
                dataStatusCronometro: null,
                idLocalMedico: "",
                nomeExame: "",
                idOrdemServico: "",
                idConsulta: "",
                idSolicitacaoPos: null,
                idSolicitacaoLaboratorio: null,
                atendimentos: []
            },
            idMedico: null,
            idPrestador: null,
            tabSolicitacoes: 0,
            loadConsultas: false,
            loadExames: false,
            loadExamesLab: false,
            seconds: 0 * 60,
            intervalos: [],
            isDelete: false,
            isDeleteLab: false,
            indexExame: 0,
            indexExameLab: 0,
            loadMoney: false,
            searchDisponiveis: '',
            search: '',
            qtdChamadasPrioridade: 0,
            listaPacientesDisponiveisFiltrada: [],
            fab: false,
            dialogMeusAtendimentos: false
        }
    },

    methods: {
        encerrarConsultas() {
            var consultas = []
            this.loadEncerrar = true

            for (let i = 0; i < this.listaConsultasPaciente.length; i++) {
                const element = this.listaConsultasPaciente[i];
                consultas.push({
                    idAtendimento: element.idAtendimento
                })
            }
            posAtendimentoService.finalizarPosConsultas(consultas).then(res => {
                //console.log(res.status);
                if (res.status == 200) {
                    this.loadEncerrar = false
                    this.iniciouAtendimento = false
                    this.exibirFicha = false
                    this.isAtendimento = false
                    this.fezChamada = false
                    this.listarPacientes()
                }
            }).finally(() => {
                this.loadEncerrar = false
                this.dialogEncerrarAtendimento = false
            })
        },
        deleteItem(item, tipo) {
            if (tipo === 1) {
                var editedIndex = this.solicitacoesExames.indexOf(item)
                //console.log(editedIndex)
                this.indexExame = editedIndex
                this.isDelete = true
            } else {
                var editedIndex = this.solicitacoesExamesLaboratoriais.indexOf(item)
                //console.log(editedIndex)
                this.indexExameLab = editedIndex
                this.isDeleteLab = true
                //this.dialogDelete = true
            }
        },
        gerarOrcamento(tipo) {
            var exames = []
            var total = 0
            var solicitacoes = tipo == 1 ? this.solicitacoesExames : this.solicitacoesExamesLaboratoriais
            solicitacoes.forEach(e => {
                total += e.valor != null ? total + e.valor : total
                exames.push({
                    nome: e.nomeExame,
                    valor: e.valor != null ? e.valor : 0
                })
            })
            var receituario = {
                exames: exames,
                paciente: '',
                solicitante: 'teste',
                os: `${total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`,
                atendimento: '',
                medicamentos: '',
                // exames: solicitacao,
                descricao: '',
                tipo: ''
            }

            posAtendimentoService.downloadRelatorioOrcamento(receituario).then(r => {
                const url = window.URL.createObjectURL(new Blob([r.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `exames.pdf`)
                document.body.appendChild(link)
                link.click()
            })
        },

        consultarOrcamentoExames() {
            var exames = []
            this.loadMoney = true
            var orcamentoExames = 0
            for (let i = 0; i < this.solicitacoesExames.length; i++) {
                const e = this.solicitacoesExames[i]
                exames.push(e.idExame)
            }
            posAtendimentoService.consultarOrcamento({
                idEmpresa: this.user.idEmpresa,
                idUnidadeNegocio: this.user.idUnidade,
                tipoSolicitacao: "CLINICA",
                exames: exames
            }).then(r => {
                if (r.status == 200) {
                    // console.log(exames.length, r.data.length)
                    if (exames.length != r.data.length) {
                        this.alertOrcamento = true
                    } else {
                        this.alertOrcamento = false
                    }
                    for (let i = 0; i < r.data.length; i++) {
                        const e = r.data[i];
                        // console.log('Solicitacão: ' ,solicitacoesExames)
                        for (let j = 0; j < this.solicitacoesExames.length; j++) {
                            const ex = this.solicitacoesExames[j];
                            if (e.id == ex.idExame) {
                                orcamentoExames = orcamentoExames + e.valor
                                ex.valor = e.valor
                            }
                        }
                    }
                    this.orcamentoExames = orcamentoExames.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    });
                }
            }).finally(() => {
                this.loadMoney = false
            })
        },
        consultarOrcamentoExamesLaboratoriais() {
            var exames = []
            this.loadMoney = true
            var orcamentoExamesLaboratoriais = 0
            for (let i = 0; i < this.solicitacoesExamesLaboratoriais.length; i++) {
                const e = this.solicitacoesExamesLaboratoriais[i]
                exames.push(e.idExame)
            }
            posAtendimentoService.consultarOrcamento({
                idEmpresa: this.user.idEmpresa,
                idUnidadeNegocio: this.user.idUnidade,
                tipoSolicitacao: "LABORATORIO",
                exames: exames
            }).then(r => {
                if (r.status == 200) {
                    if (exames.length != r.data.length) {
                        this.alertOrcamentoLaboratorial = true
                    } else {
                        this.alertOrcamentoLaboratorial = false
                    }
                    for (let i = 0; i < r.data.length; i++) {
                        const e = r.data[i];
                        //console.log('Solicitacão: ' ,solicitacoesExames);
                        for (let j = 0; j < this.solicitacoesExamesLaboratoriais.length; j++) {
                            const ex = this.solicitacoesExamesLaboratoriais[j];
                            // console.log(e.id, ex.idExame)
                            if (e.id == ex.idExame) {
                                orcamentoExamesLaboratoriais = orcamentoExamesLaboratoriais + e.valor
                                ex.valor = e.valor
                            }
                        }
                    }
                    this.orcamentoExamesLaboratoriais = orcamentoExamesLaboratoriais.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    });
                }
            }).finally(() => {
                this.loadMoney = false
            })
        },

        // Metodo para listar os exames
        listarExames(nome, sadt) {
            this.isLoading = true
            // let exames = null
            medicoService.medico.listarExamesPorNome(nome, sadt == 1 ? 'LABORATORIO' : 'CLINICA').then(r => {
                // console.log('r: ', r)
                if (r.status == 200) {
                    this.count = r.data.length
                    this.entries = r.data

                }
            }).finally(() => {
                this.isLoading = false
            })
            // return exames
        },
        // Metodo para formatar a data e hora
        formatarData(data) {
            //console.log('data: ', data);
            if (data) {
                return moment(data).format("DD/MM/YYYY HH:mm:ss");
            }
            return "";
        },
        toggle(index) {
            const i = this.selected.indexOf(index);
            if (i > -1) {
                this.selected.splice(i, 1);
            } else {
                this.selected.push(index);
            }
        },

        listarConsultas(idAtendimento) {
            this.loadConsultas = true
            posAtendimentoService.listarConsultas(idAtendimento).then(rsp => {
                // console.log('----- consultas', rsp.data)
                this.listaConsultasPaciente = rsp.data;
            }).finally(() => {
                this.loadConsultas = false
            });
        },
        listarSolicitacoesDeExames(idSolicitacao) {
            this.loadSolicitacoes = true;
            posAtendimentoService.listarSolicitacaoExames(idSolicitacao, this.ficha.idPosConsulta)
                .then(r => {
                    if (r.status == 200) {
                        for (let i = 0; i < r.data.length; i++) {
                            const e = r.data[i];
                            if (e.sadt == 1) {
                                console.log(e)
                                if (!this.solicitacoesExamesLaboratoriais.some(exame => exame.idExame === e.idExame)) {
                                    this.solicitacoesExamesLaboratoriais.push(e);
                                }
                            } else {
                                if (!this.solicitacoesExames.some(exame => exame.idExame === e.idExame)) {
                                    this.solicitacoesExames.push(e);
                                }
                            }
                        }
                    }
                })
                .finally(() => {
                    this.loadSolicitacoes = false;
                });
        },
        listarSolicitacoesMedicamentos(idConsulta) {
            posAtendimentoService.listarSolicitacaoMedicamentos(idConsulta).then(r => {
                if (r.status == 200) {
                    console.log('----- solicitacoes', r.data)
                    this.listaSolicitacoesDeMedicamentos = r.data
                }

            }).finally(() => {
                //this.load = false
            })

        },
        dialogLogout() {
            // if (
            //     this.listaPacientesEspera.length > 0 ||
            //     this.listaPacientesPendente.length > 0
            // ) {
            //     this.dialogConfirmarSaida = true;
            // } else {
            this.logout();
            // }
        },
        logout() {
            console.log("em logout..");
            //this.$router.push("/login");
            this.$store
                .dispatch("FedLogOut")
                .then(rsp => {
                    // this.limparIntervalos();
                    this.socket ? this.socket.close() : "";
                    this.$router.push("/login");
                    if (r) {}
                })
                .catch(error => {});
        },
        adicionarServicosParaAtendimento() {
            var nomeConsultorioServicos = {
                nomeConsultorio: this.descricaoLocal.valor + this.nomeConsultorio,
                servicos: this.listaServicosSelecionados
            };

            this.nomeConsultorioCompleto =
                this.descricaoLocal.valor + this.nomeConsultorio;

            this.$store.dispatch("NomeConsultorioServicos", nomeConsultorioServicos);
            this.$store.dispatch("LocalEscolhido", this.localEscolhido);
            this.refreshToken()
            this.mostrarTelaPrincipal = true
            this.listar
            this.listarPacientes()
        },
        validateField() {
            this.rulesLocal = [];
            if (this.descricaoLocal.descricao === "Consultório ") {
                var rule1 = v =>
                    v[0] != " " || "Não pode iniciar com espaço em branco!!";
                var rule2 = v =>
                    (v && v.length <= 5) || "Mínimo 1 e máximo 5 caracteres";
                this.rulesLocal.push(rule1, rule2);
            } else if (this.descricaoLocal.descricao === "Outros ") {
                var rule1 = v =>
                    v[0] != " " || "Não pode iniciar com espaço em branco!!";
                var rule2 = v =>
                    (v && v.length <= 20) || "Mínimo 1 e máximo 20 caracteres";
                this.rulesLocal.push(rule1, rule2);
            } else if (this.descricaoLocal.descricao === "Laboratório ") {
                var rule1 = v =>
                    v[0] != " " || "Não pode iniciar com espaço em branco!!";
                var rule2 = v => v.length <= 5 || "Máximo 5 caracteres";
                this.rulesLocal.push(rule1, rule2);
            } else if (this.descricaoLocal.descricao === "Sala ") {
                var rule1 = v =>
                    v[0] != " " || "Não pode iniciar com espaço em branco!!";
                var rule2 = v =>
                    (v && v.length <= 5) || "Mínimo 1 e máximo 5 caracteres";
                this.rulesLocal.push(rule1, rule2);
            }
            this.$nextTick(() => this.$refs.form.validate());
        },
        retornarLocais() {
            console.log("retornar servicos do medico..");
            medicoService.medico
                .retornarLocais(this.user.idUnidade)
                .then(rsp => {
                    console.log("rsp locais");
                    this.listaLocais = rsp.data;
                    //this.localEscolhido = localEscolhido[0];
                    console.log(this.listaLocais);
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },
        changeColor(id) {
            switch (id) {
                case 1:
                    this.exibirFicha = false
                    this.exibirListaEspera = false;
                    this.isPendentes = true;
                    this.isEspera = false;
                    break;
                case 2:
                    this.exibirFicha = false
                    this.exibirListaEspera = true;
                    this.isPendentes = false;
                    this.isEspera = true;
                    break;
                default:
                    this.isEspera = false
                    this.exibirFicha = false
                    this.exibirListaEspera = false;
                    this.isPendentes = false;
                    break;
            }
        },
        refreshToken() {
            posAtendimentoService.refreshToken(
                    getToken(),
                    this.localEscolhido.idLocal,
                    this.user.idUnidade
                )
                .then(rsp => {
                    console.log(rsp);
                    if (rsp.status == 200) {
                        console.log('VAIIII')
                        setToken(rsp.data.token);
                        this.emRefreshToken = true;
                        this.socketAux = io.connect(socketService.SOCKET_URL, {
                            query: {
                                token: getToken()
                            }
                        });

                        let connected = new Promise(
                            function (resolve, reject) {
                                this.interval = setInterval(() => {
                                    if (this.socketAux.connected) {
                                        var self = this;
                                        if (self.socket) {
                                            self.socket.destroy();
                                            delete self.socket;
                                            self.socket = null;
                                        }
                                        this.socket = this.socketAux;
                                        resolve("connected");
                                    }
                                }, 100);
                            }.bind(this)
                        );

                        connected.then(
                            function (response) {
                                if (response == "connected") {
                                    clearInterval(this.interval);
                                    console.log("promisse", response);
                                    this.chamarSocket();
                                    // this.adicionarServicos(true);
                                    // this.organizarExames(); //adicionou agora..
                                }
                            }.bind(this)
                        );
                    }
                })
                .catch(err => {
                    // handle your error here
                    console.log(err);
                });
        },
        nomeFormatado(str) {
            var arr = str.split(" ");
            if (arr[1] != null) {
                var preposicao = arr[1].toLowerCase();
                if (
                    preposicao == "de" ||
                    preposicao == "da" ||
                    preposicao == "das" ||
                    preposicao == "do" ||
                    preposicao == "dos"
                ) {
                    preposicao = true;
                } else {
                    preposicao = false;
                }
            }
            return arr.slice(0, preposicao ? 3 : 2).join(" ");
        },
        chamarSocket() {

            console.log("chamar socket");
            this.socket.on(
                "posAtendimento",
                function (mensagem) {
                    // console.log("skt atendido:", mensagem);
                    this.listarPacientes()
                }.bind(this)
            )
            this.socket.on(
                "connect",
                function (mensagem) {
                    console.log('conectou', mensagem)
                    this.mensagemNotificacaoSocket = "conectado";
                    // this.chamarModalConexao();
                    // chamar talvez aqui
                }.bind(this)
            );

            this.socket.on("connect_error", () => {
                this.mensagemNotificacaoSocket = "aguardando conexao";
                //this.chamarModalConexao();
            });

            this.socket.on(
                "disconnect",
                function () {
                    this.mensagemNotificacaoSocket = "desconectado";
                    // this.chamarModalConexao();
                }.bind(this)
            );
        },
        agruparUnidade(data) {
            if (data.length) {
                var unidadesAgrupadas = this.groupBy(data, "idUnidade");
                unidadesAgrupadas.forEach(element => {
                    var unidade = {
                        nomeUnidade: element[0].nomeUnidade,
                        idUnidade: element[0].idUnidade
                    };
                    this.listaUnidades.push(unidade);
                });
            }
        },

        agruparLocaisPorUnidade(unidade) {
            this.listaLocais = []
            this.localEscolhido = ""
            this.listaServicos = []
            this.listaServicosSelecionados = ""
            if (unidade != undefined) {
                var listaServicos = JSON.parse(
                    JSON.stringify(this.listaServicosDoMedico)
                );
                var retorno = listaServicos.filter(
                    element => element.idUnidade == unidade.idUnidade
                );
                retorno.forEach(elementRetorno => {
                    elementRetorno.nomeLocais = elementRetorno.nomeLocais.split(",");
                    elementRetorno.idLocais.split(",").forEach((element, index) => {
                        var local = {
                            idLocal: element,
                            nomeLocal: elementRetorno.nomeLocais[index],
                            idUnidade: elementRetorno.idUnidade
                        };
                        this.listaLocais.findIndex(
                                element => element.idLocal == local.idLocal
                            ) == -1 ?
                            this.listaLocais.push(local) :
                            "";
                    });
                });
            } else {
                this.listaLocais = [];
            }
        },
        // Cadastrar solicitacoes de exames 
        cadastrarSocilitacoesExames() {
            this.loadSolicitacao = true
            posAtendimentoService.cadastrarSolicitacaoDeExames({
                idPosConsulta: this.ficha.idPosConsulta,
                exames: this.solicitacoesExames,
                idFuncionario: this.user.id
            }).then(r => {
                if (r.status == 200) {
                    console.log(r.data)
                    this.ficha.idSolicitacaoPos = r.data.idSolicitacao
                    // this.gerarVoucher(this.solicitacoesExames)
                }
            }).finally(() => {
                this.loadSolicitacao = false
            })
        },

        gerarVoucher(tipo) {
            var exames = []
            var solicitacoes = tipo == 1 ? this.solicitacoesExames : this.solicitacoesExamesLaboratoriais
            solicitacoes.forEach(e => {
                exames.push({
                    id: e.idExame
                })
            })

            this.loadSolicitacao = true

            posAtendimentoService.gerarVoucher({
                exames: exames,
                idEmpresa: this.user.idEmpresa,
                idUnidadeNegocio: this.user.idUnidade,
                tipoSolicitacao: tipo == 1 ? "CLINICA" : "LABORATORIO",
                idPaciente: this.ficha.idPaciente,
                idPrestadorSolicitante: this.idPrestador, // id do medico
                idUsuario: this.idMedico,
                armazenado: false,
                obs: ""
            }).then(r => {
                if (r.status == 200 && !r.data.error) {
                    if (tipo == 1) {
                        this.cadastrarSocilitacoesExames()
                    } else {
                        this.cadastrarSocilitacoesExamesLaboratoriais()
                    }
                    console.log(r.data)
                    if (r.data.msg === 'sucesso') {

                        var exames = []
                        var total = 0
                        var solicitacoes = tipo == 1 ? this.solicitacoesExames : this.solicitacoesExamesLaboratoriais
                        solicitacoes.forEach(e => {
                            total += e.valor != null ? total + e.valor : total
                            exames.push({
                                nome: e.nomeExame,
                                valor: e.valor != null ? e.valor : 0
                            })
                        })
                        var receituario = {
                            exames: exames,
                            paciente: '',
                            atendimento: tipo == 1 ? this.orcamentoExames : this.orcamentoExamesLaboratoriais,
                            os: r.data.idOS,
                            medicamentos: '',
                            solicitante: exames.length,
                            tipo: tipo == 1 ? 'voucher' : 'voucherLaboratorio',
                            // exames: solicitacao,
                            descricao: '',

                        }

                        posAtendimentoService.downloadRelatorioVoucher(receituario).then(r => {
                            const url = window.URL.createObjectURL(new Blob([r.data]))
                            const link = document.createElement('a')
                            link.href = url
                            link.setAttribute('download', `${r.data.idOS}.pdf`)
                            document.body.appendChild(link)
                            link.click()
                        })
                    }

                    // this.listaExamesSolicitados = [];
                } else {
                    this.loadSolicitacao = false
                    this.erroVoucher = r.data.msg
                    setTimeout(() => {
                        this.erroVoucher = ''
                    }, 5000);
                }
            }).finally(() => {
                this.loadSolicitacao = false
            })
        },
        // Cadastrar solicitacoes de exames 
        cadastrarSocilitacoesExamesLaboratoriais() {
            this.loadSolicitacao = true
            posAtendimentoService.cadastrarSolicitacaoDeExames({
                    idPosConsulta: this.ficha.idPosConsulta,
                    //exames: this.solicitacoesExames,
                    examesLaboratoriais: this.solicitacoesExamesLaboratoriais,
                    idFuncionario: this.user.id
                })
                .then(r => {
                    console.log(r);
                    if (r.status == 200) {
                        this.ficha.idSolicitacaoLaboratorio = r.data.idSolicitacaoLaboratorio
                    }
                }).finally(() => {
                    this.loadSolicitacao = false
                })
        },
        listarPacientes() {
            // console.log('Listar pacientes', '--------');
            posAtendimentoService.buscarPosAtendimentoDia(this.user.idUnidade).then(r => {
                // Iterar e verificar qual o status do atendimento
                this.listaPacientesDisponiveis = []
                this.listaPacientesPendente = []
                this.listaPacientesEspera = []
                this.listaPacientesAtendimento = []
                this.listaPacientesFinalizado = []
                //console.log('atendimentos', r.data);
                for (let i = 0; i < r.data.length; i++) {
                    console.log(r.data[i].status)
                    const p = r.data[i]
                    if (p.status == 'pendente') {
                        this.listaPacientesPendente.push(p)
                    } else if (p.status == 'atendida') {
                        this.listaPacientesAtendimento.push(p)
                    } else if (p.status == 'finalizada') {
                        this.listaPacientesFinalizado.push(p)
                    } else if (p.status == 'novo') {
                        this.listaPacientesDisponiveis.push(p)
                    } else if (p.status == 'espera') {
                        this.listaPacientesEspera.push(p)
                    }

                }
                // this.listaPacientesDisponiveis = r.data
            })
        },
        iniciarAtendimento() {
            this.atendimentoAux = true
            this.iniciouAtendimento = true
            this.isAtendimento = true
            this.ficha.dataStatusCronometro = new Date().getTime();
            this.listarConsultas(this.ficha.idAtendimento)
            this.chamarCronometro()
        },
        reiniciarAtendimento() {
            this.atendimentoAux = true
            this.iniciouAtendimento = true;
            this.fezChamada = true;
            this.isAtendimento = true;
            for (let index = 0; index < this.listaPacientesEspera.length; index++) {
                if (this.listaPacientesEspera[index].idAtendimento == this.ficha.idAtendimento) {
                    this.listaPacientesEspera.splice(index, 1);
                }
            }

            this.ficha.dataStatusCronometro = new Date().getTime();

            //console.log(dataFicha, dataAgora);
            //var segundos = new Date(dataAgora) / 1000;
            // this.seconds = Math.trunc(segundos);
            //console.log('seconds: ', this.seconds)
            this.chamarCronometro();
            this.listarConsultas(this.ficha.idAtendimento)
            posAtendimentoService.alterarStatusPosAtendimento(this.ficha.idAtendimento, 'pendente').then(r => {})
            // this.mostrarFicha(this.ficha);
        },
        mostrarFicha(ficha) {
            console.log('ficha: ', ficha)
            this.ficha = ficha
            this.exibirFicha = true;
        },
        fazerChamada() {
            //ok
            console.log('fazerChamada')
            //idAtendimento, codigo, nomeConsultorio, nomeMedico,
            //nomePaciente, prioridade, idLocalMedico, nomeLocal, tecnico, automatico, idLocal
            posAtendimentoService.fazerChamada(
                this.ficha.idAtendimento,
                this.ficha.idOrdemServico,
                this.user.nomeConsultorioServicos.nomeConsultorio,
                this.user.nome,
                this.ficha.nomePaciente,
                0,
                this.user.localEscolhido.idLocal,
                this.user.localEscolhido.nomeLocal,
                2,
                0,
                this.user.localEscolhido.idLocal,
                this.user.idUnidade).then(r => {
                if (r.status == 200) {
                    console.log(r.data)
                }
            })
            // console.log(this.ficha.idAtendimento, 'pendente');
            posAtendimentoService.alterarStatusPosAtendimento(this.ficha.idAtendimento, 'pendente').then(r => {
                // console.log('fezChamada ----=', r.data)

                // this.listarPacientes()
                if (r.status == 200) {
                    // console.log('fezChamadaL ', r.data)
                    this.desabilitaBotaoChamar = true;
                    this.fezChamada = true
                    //this.iniciarCronometroRegressivo()
                    // Re-enable after 5 seconds
                    setTimeout(() => {
                        this.desabilitaBotaoChamar = false;
                    }, 15000);
                    //var automatico = false;         

                    this.listaPacientesPendente.forEach((element, index) => {
                        if (element.idAtendimento == this.ficha.idAtendimento) {
                            this.listaPacientesPendente.splice(index, 1);
                        }
                    });

                    this.habilitarBotaoCronometro == true ||
                        this.intervalContagemRegressiva ?
                        "" :
                        this.chamarCronometroRegressivo();
                    this.fezChamada = true;
                    //this.nChamada = this.nChamada + 1;
                    this.emPacientePendente = false;
                }
            })

        },
        atendimentoEmEspera() {
            var copiaFicha = this.ficha
            this.iniciouAtendimento = false
            this.exibirFicha = false
            this.isAtendimento = false
            this.fezChamada = false
            posAtendimentoService.alterarStatusPosAtendimento(this.ficha.idAtendimento, 'espera').then(r => {
                if (r.status == 200) {
                    var isPendente = false;
                    this.listaPacientesPendente.forEach((element, index) => {
                        if (element.idAtendimento == this.ficha.idAtendimento) {
                            isPendente = true;
                            this.listaPacientesPendente.splice(index, 1);
                            this.listaPacientesEspera.push(copiaFicha)
                            // this.listarPacientes()
                        }
                    })
                    if (!isPendente) {
                        this.listaPacientesDisponiveis.forEach((element, index) => {
                            if (element.idAtendimento == this.ficha.idAtendimento) {
                                isPendente = true;
                                this.listaPacientesDisponiveis.splice(index, 1);
                                this.listaPacientesEspera.push(copiaFicha)
                                // this.listarPacientes()
                            }
                        })
                    }
                    if (!isPendente) {
                        this.listaPacientesEspera.push(copiaFicha)
                    }
                }
            })

        },
        iniciarCronometroRegressivo() {
            var min = Math.floor(this.secondsRegressivo / 60);
            var sec = this.secondsRegressivo - min * 60;
            sec === 0 ? (sec = "00") : "";
            sec > 0 && sec < 10 ? (sec = "0" + sec.toString()) : "";
            this.textCronometroRegressivo =
                "[" + "0" + min.toString() + ":" + sec + "]";
            this.secondsRegressivo--;
            if (this.secondsRegressivo === -1) {
                this.textCronometroRegressivo = "";
                this.secondsRegressivo--;
                this.habilitarBotaoCronometro = true;
                clearInterval(this.intervalContagemRegressiva);
            }
        },
        chamarCronometroRegressivo() {
            // 45 seg = 0.75
            this.minutesRegressivo = 0.05;
            this.secondsRegressivo = 40;
            this.intervalContagemRegressiva = setInterval(
                () => this.iniciarCronometroRegressivo(),
                1000
            );
        },
        addSolicitacao(data, tipo) {
            let isExames = false
            // let exames = []
            // console.log(this.solicitacoesExames.length)

            if (tipo == 1) {

                this.solicitacoesExames.forEach(s => {
                    if (s.idExame == data.idExame) isExames = true
                })

                //console.log('gira em torno: ',idExame)
                if (!isExames) {
                    this.solicitacoesExames.unshift(data)
                }
                this.consultarOrcamentoExames()
                // this.consultarOrcamentoExamesLaboratoriais()
            } else {
                this.solicitacoesExamesLaboratoriais.forEach(s => {
                    // console.log(data);
                    // console.log(s.idExame, data.idExame);
                    if (s.idExame == data.idExame) isExames = true
                })
                if (!isExames) {
                    this.solicitacoesExamesLaboratoriais.unshift(data)
                    isExames = true
                }
                //this.consultarOrcamentoExames
                this.consultarOrcamentoExamesLaboratoriais()
            }

        },
        iniciarCronometroAtendimento() {
            this.seconds += 1;
            const hours = Math.floor(this.seconds / 3600);
            const minutesLeft = Math.floor(this.seconds / 60) % 60;
            const secondsLeft = this.seconds % 60;
            this.tempoAtendimento =
                this.timeDurationToString(hours) +
                ":" +
                this.timeDurationToString(minutesLeft) +
                ":" +
                this.timeDurationToString(secondsLeft);
        },
        timeDurationToString(duration) {
            return duration > 9 ? duration : "0" + duration;
        },
        chamarCronometro() {
            var i1 = setInterval(() => this.iniciarCronometroAtendimento(), 1000);
            this.intervalos.push(i1);
        },
        clearSearch() {
            this.search = ""
        }

        // agruparServicosPorLocal(local) {
        //     this.listaServicos = [];
        //     this.listaServicosSelecionados = "";
        //     if (local != undefined) {
        //         var listaServicos = JSON.parse(
        //             JSON.stringify(this.listaServicosDoMedico)
        //         );
        //         var retorno = listaServicos.filter(
        //             element => element.idUnidade == local.idUnidade
        //         );

        //         retorno.forEach(elementRetorno => {
        //             elementRetorno.idLocais = elementRetorno.idLocais.split(",");
        //             elementRetorno.exames = elementRetorno.exames.split(",");
        //             var servico = {
        //                 idServico: elementRetorno.idServico,
        //                 nomeEspecialidade: elementRetorno.nomeEspecialidade,
        //                 exames: elementRetorno.exames
        //             };
        //             elementRetorno.idLocais.find(element => element == local.idLocal) ==
        //                 undefined ?
        //                 "" :
        //                 this.listaServicos.push(servico);
        //         });
        //     } else {
        //         this.listaServicos = [];
        //     }
        // }

    },
    computed: {
        items() {
            return this.entries.map(entry => {
                const Description = entry.nome.length > this.nome ?
                    entry.nome.slice(0, this.descriptionLimit) + '...' :
                    entry.nome
                return Object.assign({}, entry, {
                    Description
                })
            })
        }
    },

    mounted() {
        this.user = this.$store.getters.usuario;
        console.log("mounted user", this.user);
        if (this.user.idEmpresa == 4) {
            this.idUnidadeNegocio = 981;
        } else if (this.user.idEmpresa == 11) {
            this.idUnidadeNegocio = 295;
        } else if (this.user.idEmpresa == 9) {
            this.idUnidadeNegocio = 133;
        }
        this.retornarLocais()
        this.socket = io.connect(socketService.SOCKET_URL, {
            query: {
                token: getToken()
            }
        });
        if (this.user.tipo != 12) {
            this.$router.push("/login");
            return;
        }
        if (this.user.localEscolhido.idLocal != null &&
            this.user.nomeConsultorioServicos.nomeConsultorio != null) {
            this.localEscolhido = this.user.localEscolhido.nomeLocal;
            this.mostrarTelaPrincipal = true

            this.chamarSocket()
            this.listarPacientes()
        }
        
        //  console.log("mounted user", this.user.localEscolhido != null)

        // this.localEscolhido = this.user.localEscolhido.nomeLocal;
        //console.log("mounted user", this.localEscolhido);
        //this.agruparLocaisPorUnidade(this.localEscolhido);
        //this.agruparServicosPorLocal(this.localEscolhido);

    },
    //  this.chamarSocket();

    watch: {
        solicitacoesExamesLaboratoriais() {
            this.orcamentoExamesLaboratoriais = 0
            this.$nextTick(() => {
                this.searchExame2 = ''
                this.exame2 = ''
            })
            if (this.solicitacoesExamesLaboratoriais.length > 0) {
                this.consultarOrcamentoExamesLaboratoriais()
            }
        },
        solicitacoesExames(val) {
            this.orcamentoExames = 0
            this.$nextTick(() => {
                this.searchExame = ''
                this.exame1 = ''
            })
            if (this.solicitacoesExames.length > 0) {
                this.consultarOrcamentoExames()
            }
        },
        exame1(val) {
            console.log('em watch')
            if (val != '') {
                // console.log('adcionou exame 1', val)
                this.addSolicitacao(val, 1)
            } else {
                console.log('else watch')
            }
        },
        exame2(val) {
            if (val != '') {
                // console.log('adcionou exame 1', val)
                this.addSolicitacao(val, 0)
            }
        },
        searchExame(val) {
            console.log('--', val)
            if (val != null && val != '') {
                this.listarExames(val, 0)
            }
        },
        searchExame2(val) {
            console.log(val)
            if (val != null && val != '') {
                this.listarExames(val, 1)
            }
        },
        tabSolicitacoes(val) {
            switch (val) {
                case 0: {
                    console.log('exames')
                    break;
                    // Chamar métodos de carregadar exames clinicos
                }
                case 1: {
                    console.log('exames lab')
                    break;
                    // Chamar métodos de carregadar Exames laboratório
                }
                case 2: {
                    console.log('medicamentos')
                    break;
                    // Chamar métodos de carregadar medicamentos
                }
            };
        },
        exibirSolicitacoes(val) {
            if (val == false) {
                this.solicitacoesExames = []
                this.solicitacoesExamesLaboratoriais = []
            }
        },
        listaPacientesDisponiveis: function (val) {
            console.log('aaa')
            this.qtdChamadasPrioridade = 0
            val.forEach(element => {
                if (element.prioridade == 1 || element.prioridade == 3) {
                    this.qtdChamadasPrioridade += 1
                }
            });

            this.listaPacientesDisponiveisFiltrada = this.listaPacientesDisponiveis.filter(item => {
                if (!this.searchDisponiveis) {
                    return this.listaPacientesDisponiveis;
                }
                return item.nomePaciente
                    .toLowerCase()
                    .includes(this.searchDisponiveis.toLowerCase());
            });
        },
        searchDisponiveis() {
            this.listaPacientesDisponiveisFiltrada = this.listaPacientesDisponiveis.filter(item => {
                if (!this.searchDisponiveis) return this.listaPacientesDisponiveis;
                return item.nomePaciente
                    .toLowerCase()
                    .includes(this.searchDisponiveis.toLowerCase());
            });
            console
        },

    }
}
</script>

<style scoped>
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.scrollable {
    overflow-y: auto;
}

#mybutton2 {
    position: fixed;
    bottom: 60px;
    right: 180px;
}

#fade {
    animation: bounce;
    /* referring directly to the animation's @keyframe declaration */
    animation-duration: 2s;
    /* don't forget to set a duration! */
}

.tile {
    margin: 0px;
    border-radius: 3px;
    background: rgb(167, 160, 160);
}

.rounded-card {
    border-radius: 50px;
}

.mensagemInicial {
    font-family: "Merriweather", serif;
    font-size: 21px;
}
</style>
